export type GlyphSegment = { pathData: string; color: string };

export function renderGlyphSegments(
  ctx: CanvasRenderingContext2D,
  glyphSegments: GlyphSegment[],
) {
  if (typeof Path2D === "undefined" || glyphSegments.length === 0) return;

  // Pass 1: fill each glyph with its assigned color
  for (const { pathData, color } of glyphSegments) {
    if (!pathData) continue;
    const glyphPath = new Path2D(pathData);
    ctx.fillStyle = color;
    ctx.fill(glyphPath);
  }
}
